import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import TableViewIcon from "@mui/icons-material/TableView";
import RemoveIcon from "@mui/icons-material/Remove";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  InputAdornment,
  ListItemIcon,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Booking from "../api/booking";
import "../App.css";
// !------
import { AG_GRID_LOCALE_FR } from "@ag-grid-community/locale";
import { ColumnApiModule, ModuleRegistry } from "ag-grid-community";
import ContractDetails from "../components/ContractDetails";
import LokaSnackBar from "../components/LokaSnackBar";
import Colors from "../constants/colors.json";
import Language from "../constants/language_fr.json";
import SnackBarContext from "../Contexts/SnackBarContext";
import { Tooltip } from "@mui/material";
import LokaActivityIndicator from "../components/LokaActivityIndicator";
import ActivityIndicatorContext from "../Contexts/ActivityIndicatorContext";
import { useSelector } from "react-redux";

const BookingsView = () => {
  ModuleRegistry.registerModules([ColumnApiModule]);
  const { setActivityIndicator } = useContext(ActivityIndicatorContext);
  const { members, user } = useSelector(({ slice }) => slice.value);
  const { setSnackBar } = useContext(SnackBarContext);

  const { GetApiCompanyDiscountGrid, GetGridBookings, Update } = Booking || {};
  const [anchorEl, setAnchorEl] = useState();
  const [columnDefs, setColumnDefs] = useState();
  const [contractDetails, setContractDetails] = useState(null);
  const [isViewAdding, setIsViewAdding] = useState(false);
  const [localProps, setLocalProps] = useState({
    isGridReady: false,
  });
  const [search, setSearch] = useState();
  const [view, setView] = useState("Standard");

  const gridRef = useRef(null);
  const addViewInputRef = useRef(null);

  const constructor = async () => {
    setActivityIndicator({
      isOpen: true,
      message: Language.appBar.loading,
    });

    const { data } = await GetGridBookings({
      token: user?.token,
    });
    const companyDiscountGrid = await GetApiCompanyDiscountGrid({
      idCompany: user.idCompany,
      token: user.token,
    });
    const bookingsList = data?.response || [];
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    const { columnDefs: _columnDefs, viewDefs } = agGridConfig?.booking;

    setColumnDefs(_columnDefs);
    setLocalProps({
      companyDiscountGrid,
      defaultViews: viewDefs?.length
        ? viewDefs
        : [
            "Standard",
            "Planning",
            "Compteur",
            "Type_contrat",
            "Facturation",
            "Export",
          ],
      rowData: bookingsList,
    });
    setActivityIndicator({
      isOpen: false,
      message: null,
    });
  };
  useEffect(() => {
    constructor();
  }, []);

  const getMember = (memberId) => {
    const _member = members?.find(({ id }) => id === memberId[0]);
    return _member ? `${_member?.firstName} ${_member?.lastName}` : ``;
  };

  const gridApiHandler = (apiType) => {
    const { api } = gridRef.current || {};
    if (api) {
      switch (apiType) {
        case "exportDataAsExcel":
          api.exportDataAsExcel();
          break;
        default:
          console.log("This grid api type is not used in INSPEKT app.");
      }
    }
  };

  const handleAddView = () => {
    const addViewTextField = addViewInputRef?.current?.value;
    const viewName = addViewTextField?.replaceAll(" ", "_");
    const _viewDefs = [...localProps?.defaultViews, viewName];
    const _columnDefs = {
      ...columnDefs,
      [viewName]: columnDefs?.Standard,
    };
    setLocalProps((_localProps) => ({
      ..._localProps,
      defaultViews: _viewDefs,
    }));
    setColumnDefs(_columnDefs);
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        ...agGridConfig,
        booking: { columnDefs: _columnDefs, viewDefs: _viewDefs },
      })
    );
    setIsViewAdding(false);
  };

  const handleUpdateColumn = ({ isActive, key }) => {
    const _columnDefs = isActive
      ? {
          ...columnDefs,
          [view]: columnDefs?.[view].filter((item) => item !== key),
        }
      : { ...columnDefs, [view]: [key, ...columnDefs?.[view]] };
    setColumnDefs(_columnDefs);
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        ...agGridConfig,
        booking: { ...agGridConfig?.booking, columnDefs: _columnDefs },
      })
    );
  };

  const handleCloseAndRefresh = async ({ snackbar }) => {
    const { isOpen, message, status } = snackbar || {};
    constructor();
    setContractDetails(null);
    setSnackBar({
      isOpen: isOpen,
      message: message,
      status: status,
    });
  };

  const handleCloseBooking = async ({ _id }) => {
    const [_booking] = await Booking.CloseBookings({
      bookings: [_id],
      token: user?.token,
    });
    if (_booking) {
      const _rowData = rowData?.map((data) =>
        data?.jsonObject?._id === _booking?.jsonObject?._id ? _booking : data
      );
      setLocalProps((_localProps) => ({ ...localProps, rowData: _rowData }));
      setSnackBar({
        isOpen: true,
        message: Language.addBooking.closeBookingSuccess,
        status: "success",
      });
    } else {
      setSnackBar({
        isOpen: true,
        message: Language.addBooking.closeBookingError,
        status: "success",
      });
    }
  };

  const handleMergeBooking = ({ booking }) => {
    setContractDetails(booking);
    constructor();
  };

  const handleSearch = ({ target }) => {
    setSearch(target?.value);
  };

  const handleStoreColumnDefs = () => {
    const { api } = gridRef.current || {};
    const _activeViewcolumnDefs = api?.getColumnDefs();
    setColumnDefs((_columnDefs) => ({
      ..._columnDefs,
      [view]: _activeViewcolumnDefs?.map(({ colId }) => colId),
    }));

    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        ...agGridConfig,
        booking: {
          ...agGridConfig?.booking,
          columnDefs: {
            ...agGridConfig?.booking?.columnDefs,
            [view]: _activeViewcolumnDefs?.map(({ colId }) => colId),
          },
        },
      })
    );
  };

  const handleCompareDates = (a, b) => {
    const [aDay, aMonth, aYear] = a?.split("/") || [];
    const [bDay, bMonth, bYear] = b?.split("/") || [];
    const aDate = a ? new Date(aYear, aMonth, aDay) : null;
    const bDate = b ? new Date(bYear, bMonth, bDay) : null;
    return aDate === bDate ? 0 : aDate > bDate ? 1 : -1;
  };

  const handleGetBookingType = ({ data }) =>
    localProps?.companyDiscountGrid?.find(
      ({ key }) => key === data.contractType
    )?.label || "LOCATION";

  const onFirstDataRendered = (params) => {
    /**Display data on full width */
    params.api.sizeColumnsToFit();
  };

  const columnsConfiguration = {
    billId: {
      colId: "billId",
      editable: true,
      headerName: "N° facture",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) => data.billId,
      valueSetter: ({ data, newValue, oldValue }) => {
        const isBookingBillable =
          newValue !== oldValue &&
          ["invoiced", "closed", "needLokerVerification"].includes(data.status);
        if (isBookingBillable) {
          updateBillId({
            booking: data?.jsonObject,
            newBillId: newValue,
            oldBillId: oldValue,
          });

          data.billId = newValue;
          data.status = newValue?.length ? "invoiced" : "closed";
        } else {
          setSnackBar({
            isOpen: true,
            message: Language.addBooking.thisBookingIsNotBillable,
            status: "error",
          });
        }

        return isBookingBillable ? true : false;
      },
    },
    bookingStatus: {
      colId: "bookingStatus",
      field: "bookingStatus",
      headerName: "Statut",
      type: "textColumn",
      valueGetter: ({ data }) => Language.bookingStatusRenderer?.[data.status],
      width: 120,
    },
    brand: {
      colId: "brand",
      field: "brand",
      headerName: "Marque",
      type: "textColumn",
      width: 120,
    },
    contractType: {
      colId: "contractType",
      field: "contractType",
      headerName: "Type contrat",
      type: "textColumn",
      valueGetter: handleGetBookingType,
    },
    checker: {
      colId: "checker",
      field: "checker",
      headerName: "Checker",
      type: "textColumn",
      valueGetter: ({ data }) => getMember([data?.checker]),
      width: 120,
    },
    createdAt: {
      colId: "createdAt",
      comparator: handleCompareDates,
      field: "createdAt",
      headerName: "Date de création",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.createdAt)
          .toLocaleString("fr-FR", {
            timeZone: "UTC",
          })
          .split(" ");
        return date;
      },
      width: 120,
    },
    createdBy: {
      colId: "createdBy",
      field: "createdBy",
      headerName: "Loker",
      type: "textColumn",
      valueGetter: ({ data }) => getMember([data.createdBy]),
      width: 120,
    },
    comment: {
      colId: "comment",
      field: "comment",
      headerName: "Commentaire",
      type: "textColumn",
      width: 350,
    },
    customer: {
      colId: "customer",
      field: "customer",
      headerName: "Client",
      type: "textColumn",
    },
    customerID: {
      colId: "customerID",
      field: "customerID",
      headerName: "ID Client",
      type: "textColumn",
    },
    departureAgency: {
      colId: "departureAgency",
      field: "departureAgency",
      headerName: "Agence départ",
      type: "textColumn",
      width: 120,
    },
    discount: {
      colId: "discount",
      field: "discount",
      headerName: "Remise",
      type: "textColumn",
    },
    internId: {
      colId: "internId",
      field: "internId",
      headerName: "N° parc",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) => data.internId,
    },
    machineState: {
      colId: "machineState",
      field: "machineState",
      headerName: "Etat",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) =>
        Language.machineStateConverter?.[data?.machineState] || "",
    },
    minIncome: {
      colId: "minIncome",
      field: "minIncome",
      headerName: "Revenu (min)",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) => data.minIncome,
    },
    model: {
      colId: "model",
      field: "model",
      headerName: "Modèle",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) => data.model,
    },
    nature: {
      colId: "nature",
      headerName: "Nature",
      type: "textColumn",
      valueGetter: ({ data }) => Language.categoryConverter?.[data.category],
      width: 120,
    },
    netPrice: {
      colId: "netPrice",
      cellRenderer: ({ data }) => {
        const _netPrice = parseFloat(data.netPrice);
        return isNaN(_netPrice) ? null : `${_netPrice.toFixed(2)}€`;
      },
      headerName: "Total HT (prév.)",
      type: "agNumberColumnFilter",
      valueGetter: ({ data }) => {
        const _netPrice = parseFloat(data.netPrice);
        return isNaN(_netPrice) ? null : _netPrice;
      },
    },
    realCounter: {
      colId: "realCounter",
      filter: "agNumberColumnFilter",
      headerName: "Compteur (heures/bottes)",
      valueGetter: ({ data: { realCounter } }) => {
        const _realCounter = Number(realCounter);
        return isNaN(_realCounter) ? null : _realCounter;
      },
    },
    realNetPrice: {
      colId: "realNetPrice",
      cellRenderer: ({ data }) => {
        const _realNetPrice = parseFloat(data.realNetPrice);
        return isNaN(_realNetPrice) ? null : `${_realNetPrice.toFixed(2)}€`;
      },
      headerName: "Total HT (réel)",
      type: "agNumberColumnFilter",
      valueGetter: ({ data }) => {
        const _netPrice = parseFloat(data.netPrice);
        return isNaN(_netPrice) ? null : _netPrice;
      },
    },
    serialNumber: {
      colId: "serialNumber",
      field: "serialNumber",
      headerName: "N° de série",
      type: "textColumn",
      width: 120,
      valueGetter: ({ data }) => data.serialNumber,
    },
    shortId: {
      colId: "shortId",
      field: "shortId",
      headerName: "Id",
      type: "textColumn",
    },
    startDay: {
      colId: "startDay",
      field: "startDay",
      filter: "agDateColumnFilter",
      comparator: handleCompareDates,
      filterParams: {
        buttons: ["clear", "apply"],
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const dateAsString = cellValue;
          if (dateAsString == null) return -1;
          const dateParts = dateAsString.split("/");
          const cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
          );
          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
          }
          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          }
          if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
      },
      headerName: "Départ",
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.startDay)
          .toLocaleString("fr-FR", {
            timeZone: "UTC",
          })
          .split(" ");
        return date;
      },
      width: 120,
    },
    startEngineHours: {
      colId: "startEngineHours",
      filter: "agNumberColumnFilter",
      headerName: "Compteur départ",
      valueGetter: ({ data: { startEngineHours } }) => {
        const _startEngineHours = Number(startEngineHours);
        return isNaN(_startEngineHours) ? null : _startEngineHours;
      },
    },
    stopDay: {
      colId: "stopDay",
      comparator: handleCompareDates,
      field: "stopDay",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      headerName: "Retour",
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.stopDay)
          .toLocaleString("fr-FR", {
            timeZone: "UTC",
          })
          .split(" ");
        return date;
      },
    },
    stopEngineHours: {
      colId: "stopEngineHours",
      filter: "agNumberColumnFilter",
      headerName: "Compteur retour",
      valueGetter: ({ data: { stopEngineHours } }) => {
        const _stopEngineHours = Number(stopEngineHours);
        return isNaN(_stopEngineHours) ? null : _stopEngineHours;
      },
    },
  };

  const defaultColDef = useMemo(() => ({
    resizable: true,
    rowSelection: "multiple",
    filter: true,
    suppressMenu: true,
  }));

  const rowClassRules = {
    "status-closed": function (params) {
      return params.data.status === "closed";
    },

    "status-invoiced": function (params) {
      return params.data.status === "invoiced";
    },
  };

  const getContextMenuItems = useCallback(({ node }) => [
    {
      disabled:
        node?.data?.status === "invoiced" || user?.licence !== "manager",
      name: "Clôturer",
      action: () => handleCloseBooking({ _id: node.data?.jsonObject?._id }),
      tooltip: "Clôturer ce contrat",
    },
  ]);

  const updateBillId = async ({ booking, newBillId, oldBillId }) => {
    /**Updating billId is the only way to set a stage to "invoiced"
     * @mikl
     */
    const _stage = newBillId?.length ? "invoiced" : "closed";
    const _booking = { ...booking, billId: newBillId, stage: _stage };
    const { status } =
      newBillId !== oldBillId
        ? await Update({ booking: _booking, token: user?.token })
        : "no update to send";
    status === 200 &&
      setSnackBar({
        isOpen: true,
        message: Language.addBooking.updateBookingSuccess,
        status: "success",
      });
  };

  const { defaultViews, rowData = [] } = localProps || {};
  const withSearchRowData = rowData?.filter((_booking) =>
    search?.length
      ? JSON.stringify(_booking)?.toLowerCase().includes(search?.toLowerCase())
      : true
  );

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: "100%", margin: "1%", paddingBottom: "5%" }}
    >
      <Box
        key="viewTitle"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2%",
          marginBottom: "2%",
          borderBottomColor: Colors.greyHighShaded,
          borderBottomWidth: 1,
          borderBottomStyle: "solid",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="view-select-label">Vues</InputLabel>
            <Select
              labelId="view-select-label"
              id="view-select"
              value={view}
              label="Vue"
              onChange={({ target }) => setView(target.value)}
            >
              {defaultViews?.map((view) => (
                <MenuItem key={view} value={view}>
                  {view}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box>
            {isViewAdding ? (
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "1vh",
                }}
              >
                <TextField
                  inputRef={addViewInputRef}
                  size="small"
                  id="add-view"
                  variant="outlined"
                  placeholder="Nom de la vue"
                />
                <Tooltip title={Language.calendar.editGridView}>
                  <SaveIcon
                    style={{
                      color: Colors.green,
                      cursor: "pointer",
                      marginLeft: 5,
                    }}
                    onClick={() => handleAddView()}
                  />
                </Tooltip>
              </Box>
            ) : (
              <Tooltip title={Language.calendar.editGridView}>
                <AddIcon
                  style={{
                    color: Colors.green,
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                  onClick={() => setIsViewAdding(true)}
                />
              </Tooltip>
            )}
          </Box>
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <TextField
            size="small"
            onChange={({ target }) =>
              handleSearch({
                target,
              })
            }
            placeholder="Rechercher"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment>
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            sx={{ minWidth: 150 }}
            value={search}
          ></TextField>
          <Tooltip title={Language.calendar.editGridView}>
            <TableViewIcon
              style={{
                color: Colors.green,
                cursor: "pointer",
                marginLeft: 5,
              }}
              onClick={(e) => setAnchorEl(e.currentTarget)}
            />
          </Tooltip>
          <Menu
            id="edit-grid"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {Object.entries(columnsConfiguration)
              ?.map(([key, { headerName }]) => ({
                isActive: columnDefs?.[view]?.includes(key),
                key,
                headerName,
              }))
              .sort((a, b) => (a.headerName > b.headerName ? 1 : -1))
              ?.map(({ isActive, key, headerName }) => (
                <MenuItem onClick={() => handleUpdateColumn({ key, isActive })}>
                  <ListItemIcon>
                    {isActive ? (
                      <RemoveIcon style={{ color: Colors.warning }} />
                    ) : (
                      <AddIcon style={{ color: Colors.green }} />
                    )}
                  </ListItemIcon>
                  {headerName}
                </MenuItem>
              ))}
          </Menu>
          <Tooltip title={Language.calendar.refreshData}>
            <RefreshIcon
              style={{ color: Colors.green, cursor: "pointer", marginLeft: 5 }}
              onClick={() => constructor()}
            />
          </Tooltip>
          <Tooltip title={Language.calendar.downloadBookings}>
            <DownloadIcon
              style={{ color: Colors.green, cursor: "pointer", marginLeft: 5 }}
              onClick={() => gridApiHandler("exportDataAsExcel")}
            />
          </Tooltip>
        </Box>
      </Box>
      {withSearchRowData?.length && columnDefs?.[view] && (
        <div className="ag-theme-grid">
          <AgGridReact
            onColumnMoved={() => handleStoreColumnDefs()}
            autoSizeStrategy={{ type: "fitGridWidth" }}
            localeText={AG_GRID_LOCALE_FR}
            rowData={withSearchRowData}
            rowClassRules={rowClassRules}
            domLayout="autoHeight"
            ref={gridRef}
            defaultColDef={defaultColDef}
            rowStyle={{
              borderBottomWidth: 1,
              borderColor: Colors.greyShaded,
              textAlign: "center",
              fontSize: "12px",
              cursor: "pointer",
            }}
            rowHeight={50}
            onCellClicked={({ data: { jsonObject }, colDef: { headerName } }) =>
              headerName !== "N° facture" && setContractDetails(jsonObject)
            }
            paginationPageSize={100}
            pagination={true}
            onFirstDataRendered={onFirstDataRendered}
            columnDefs={columnDefs?.[view]?.map(
              (colKey) => columnsConfiguration?.[colKey]
            )}
            allowContextMenuWithControlKey={true}
            // cellSelection={true}
            getContextMenuItems={getContextMenuItems}
          />
        </div>
      )}
      {contractDetails !== null && (
        <ContractDetails
          contractDetails={contractDetails}
          discountGrid={localProps.companyDiscountGrid}
          handleMergeBooking={(props) => handleMergeBooking(props)}
          setContractDetails={setContractDetails}
          handleCloseAndRefresh={(props) => handleCloseAndRefresh(props)}
        />
      )}
      <LokaSnackBar />
      <LokaActivityIndicator />
    </div>
  );
};

export default BookingsView;
